import approvalController from "./approval/approval.controller";
import approvalTemplate from "./approval/approval.html";
import rejectController from "./reject/controller";
import rejectTemplate from "./reject/reject.html";
import remindTemplate from "./remind/template.html";
import remindController from "./remind/controller";
import reviewTemplate from "./review/template.html";
import reviewController from "./review/controller";

export {
  approvalController,
  approvalTemplate,
  rejectController,
  rejectTemplate,
  remindController,
  remindTemplate,
  reviewTemplate,
  reviewController
}



// WEBPACK FOOTER //
// ./client/pages/review/modals/index.js